import { cacheDom } from "../utils/QuerySelectors.js"
import { addItemsToCart } from "../utils/Cart.js"

const dom = {}
const qs = {
  swiperWrapper: 'data-look-slider',
  addAll: 'data-add-all',
  swatchVariant: 'data-swatch-variant',
}
const qsAll = {
  sections: 'data-section-type="shop-the-look"',
  pins: 'data-hotspot-pin',
}

const initSection = (section) => {
  const swiperWrapper = section.querySelector(`[${qs.swiperWrapper}]`)
  const swiperInstance = new Swiper(swiperWrapper, {
    spaceBetween: 50,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      slideChange: function (swiper) {
        const pin = section.querySelector(`[data-hotspot-pin="${swiper.activeIndex}"]`)
        pin?.dispatchEvent(new Event('click'))
      },
    },
  })
  const pins = section.querySelectorAll(`[${qsAll.pins}]`)
  pins.forEach(pin => {
    pin.addEventListener('click', () => {
      pins.forEach(p => p.classList.remove('shop-the-look--hotspot__selected'))
      pin.classList.add('shop-the-look--hotspot__selected')

      const index = pin.getAttribute(`${qsAll.pins}`)
      swiperInstance.slideTo(index)
    })
  })

  const addAll = section.querySelector(`[${qs.addAll}]`)
  addAll?.addEventListener('click', () => {
    const items = Array.from(section.querySelectorAll(`.selected[${qs.swatchVariant}]`))
      .map(swatch => { 
        return { id: swatch.getAttribute(qs.swatchVariant), quantity: 1 }
      })
    if(items.length > 0) {
      addItemsToCart(items, true, addAll)
    }
  })
}

export const setupShopTheLook = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach(section => initSection(section))
}